import request from '@/utils/request';
//活动分页
export function getActivityList(values) {
  return request('/activityCoupon/queryActivityList', {
    method: 'POST',
    data: values,
  });
}
//删除活动
export function activityDelete(values) {
  return request('/activityCoupon/delete', {
    method: 'POST',
    data: values,
  });
}
//审核活动
export function activityApprove(values) {
  return request('/activityCoupon/approve', {
    method: 'POST',
    data: values,
  });
}
//终止活动
export function activityPause(values) {
  return request('/activityCoupon/terminate', {
    method: 'POST',
    data: values,
  });
}
